<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

      <van-form
          @submit="onSubmit"
          @failed="onFailed"
          style="min-height: 90vh;"
      >
        <div v-for="(member,index) in row.member_list" :key="index">
          <van-divider>人员信息{{ index + 1 }}
          </van-divider>
          <van-cell-group>
            <van-cell
                readonly
                input-align="right"
                :title="'人员'+(index+1)"
                :label="member.num"
                :value="member.name"
            >
              <template #right-icon>
                <van-icon @click="memberRemove(member,index)" name="close" style="margin-top: 5px ; margin-left: 10px"/>
              </template>
            </van-cell>

            <van-field
                name="radio" label="性别"
                input-align="right">
              <template #input>
                <van-radio-group v-model="member.sex" direction="horizontal">
                  <van-radio checked-color="#ffb01b" name="男">男</van-radio>
                  <van-radio checked-color="#ffb01b" name="女">女</van-radio>
                </van-radio-group>
              </template>
            </van-field>


            <van-field
                v-model="member.weixin"
                :rules="[]"
                error-message-align="right"
                label="微信号"
                input-align="right"
                clearable
                placeholder="请输入微信号"
            />

            <van-field
                v-model="member.phone"
                :rules="[{ required: true,message:'请输入正确的手机号'}]"
                error-message-align="right"
                label="手机"
                input-align="right"
                clearable
                placeholder="请输入手机"
            />
            <!--                  <van-field-->
            <!--                      v-model="member.csize"-->
            <!--                      error-message-align="right"-->
            <!--                      v-show="row.gametype == 3"-->
            <!--                      clearable-->
            <!--                      @click-left-icon="cSizeShow = true"-->
            <!--                      :rules="[]"-->
            <!--                      label="衣服尺码"-->
            <!--                      placeholder="请输入尺码"-->
            <!--                      input-align="right"-->
            <!--                  />-->
            <!--                  <van-field-->
            <!--                      v-model="member.footsize"-->
            <!--                      clearable-->
            <!--                      :rules="[]"-->
            <!--                      error-message-align="right"-->
            <!--                      label="鞋  码"-->
            <!--                      v-show="row.gametype == 3"-->
            <!--                      @click-left-icon="fSizeShow = true"-->
            <!--                      placeholder="请输入鞋码"-->
            <!--                      input-align="right"-->
            <!--                  />-->
            <van-cell center title="是否参加能力测试" v-show="row.gametype == 3">
              <template #right-icon>
                <van-switch v-model="member.is_join_exame" active-color="#ffad19" :active-value="1" :inactive-value="2"
                            size="24"/>
              </template>
            </van-cell>
            <!--                  <div @click="fSizeShow=true" class="operate-desc-left" v-if="formData.pay_status==2">查看鞋码表,已付款禁止修改 </div>-->
            <!--                  <div @click="fSizeShow=true" class="operate-desc-left" v-else >查看鞋码表</div>-->
            <van-field
                v-show="row.gametype == 3"
                v-model="member.join_exame_name"
                error-message-align="right"
                label="技术等级测试项目"
                input-align="right"
                clearable
                placeholder="请输入技术等级测试项目"
            />
            <div class="operate-desc-left" v-show="row.gametype == 3">技巧/花球/街舞/爵士</div>
            <van-field
                readonly
                clickable
                right-icon="arrow"
                input-align="right"
                error-message-align="right"
                @click="thisMemberIndex = index;showServiceTypePicker=true"
                label="服务套餐"
                :rules="[{ required: true,message:'请选择服务套餐'}]"
                v-model="member.serviceName"
            />
            <div  class="operate-desc-left">{{member.serviceDesc}}</div>
 

            <div  v-for="(field,fileindex) in row.extra_field" 
                 :key="fileindex">
            <div 
                  v-if="field.type=='text'"> 
                      <van-field
                          v-model="member.jsondata[field.label]"
                          :rules="[{ required: field.required,message:'请输入'+field.label}]"
                          error-message-align="right"
                          :label="field.label"
                          input-align="right"
                          clearable
                          :placeholder="'请输入'+field.label"
                      />
                  </div>

            <div 
                  v-if="field.type=='select'"> 
            <van-field
                name="radio" :label="field.label"  :rules="[{ required: field.required,message:'请选择'+field.label}]"
                input-align="right">
              <template #input>
                <van-radio-group v-model="member.jsondata[field.label]" direction="horizontal">
                  <van-radio checked-color="#ffb01b" :key='fri' v-for="(frv,fri) in field.rules" :name="frv">{{frv}}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            </div>

            <div 
                  v-if="field.type=='checkbox'"> 
            <van-field
                name="radio" :label="field.label"  
                input-align="right"
                :rules="[{
                validator: validator.arrayMin,
                trigger: 'change',
                min: field.required?1:0,
                message: '请至少选择一项', 
                }]"
                >
              <template #input>
                <van-checkbox-group v-model="member.jsondata[field.label]"  direction="horizontal">
                  <van-checkbox checked-color="#ffb01b" :key='fri' v-for="(frv,fri) in field.rules" :name="frv">{{frv}}</van-checkbox>
                </van-checkbox-group>
 
              </template>
            </van-field>
            </div>

            <div    v-if="field.type=='pic'"  v-show="!((row.cplimits.length>0||row.jllimits.length>0) &&field.label=='资质证明'  && member.levelPass)"> 
                <!-- <van-cell :title="field.label" :value="row.grade_pics.length+'/1'">  --> 
            <van-field
                v-model="member.jsondata[field.label]"
                :formatter="() =>{ return ''}"
                name="radio" :label="field.label"  :rules="[{
                validator: validator.arrayMin,
                trigger: 'change',
                min: field.required ?1:0 ,
                message: '请上传/选择图片', 
                }]"
                input-align="right">

            </van-field>
                <!-- </van-cell> -->

                <div class="row">
                    <PicUploader :fileList="member.jsondata[field.label]"  :limit="1"
                                :name="'heying'"></PicUploader>
                </div>
            </div>

              <!-- <div @click="fieldclick(field)" v-show="field.desc && !((row.cplimits.length>0||row.jllimits.length>0) &&field.label=='资质证明'  && member.levelPass)" class="operate-desc-left">{{ field.desc }}</div> -->
              <div @click="fieldclick(field)" v-show="field.desc && field.desc.includes('尺码表')" class="operate-desc-left">{{ field.desc }}</div>
            </div>
          </van-cell-group>
        </div>


        <div style="text-align: center">
          <!-- row.gametype == 3 &&  -->
          <van-button
              v-if="row.member_list.length==0 || (row.member_list.length < row.stationlimitmember)"
              native-type="button"
              style="width: 3rem; margin-top: 0.4rem"
              size="normal" round icon="plus" @click="onMemberAdd">新增人员
          </van-button>
        </div>

        <!-- <div @click="cSizeShow=true" v-show="cSizePicList.length>0" style="text-align:center;margin-top:20px" class="operate-desc-left;"  >查看衣服尺码表</div> -->


        <div style="height: 100px"></div>

        <div class="savebtn">
          <van-button
            v-show="!$route.query.edit"
              style="width: 3rem"
              size="normal" native-type="button" round @click="goPre()">上一步
          </van-button>
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
            保存
          </van-button>
        </div>
      </van-form>
    </van-pull-refresh>
    <van-button
        v-if="row.gametype == 3"
        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
        style="
    bottom: 80px;
    right: 10px;
    z-index: 10;
    position: fixed;"
        size="normal" round
        round @click.native="showTemplate = true">导入模板
    </van-button>

    <van-popup v-model="showServiceTypePicker" v-if="row.member_list.length>0" position="bottom">
      <van-picker :columns="serviceTypeColumns"
                  show-toolbar
                  :default-index="row.member_list[thisMemberIndex].serviceType-1"
                  @cancel="showServiceTypePicker = false"
                  @confirm="onServiceConfirm"
      />
    </van-popup>

    <van-popup
        position="bottom"
        :style="{ height: '50%' }"
        v-model="addShow"
        @click-overlay="addShow=false"
    >
      <div style="margin-top: 0.2rem ; margin-bottom: 1.5rem">
        <van-form
            @submit="onMemberSubmit"
            @failed="onFailed"
        >
          <van-divider>新增人员</van-divider>
          <van-cell-group>
            <van-field
                v-model="formData.name"
                label="姓名"
                :rules="[{ required: true, message: '姓名不能为空' }]"
                error-message-align="right"
                input-align="right"
                clearable
                placeholder="请输入姓名"
            />
            <van-field
                readonly
                clickable
                right-icon="arrow"
                input-align="right"
                @click="showNumTypePicker=true"
                label="证件类型"
                v-model="formData.numTypeName"
            />
            <van-popup v-model="showNumTypePicker" position="bottom">
              <van-picker :columns="numTypeColumns"
                          show-toolbar
                          :default-index="formData.cardtype-1"
                          @cancel="showNumTypePicker = false"
                          @confirm="onNumTypeConfirm"
              />
            </van-popup>


            <van-field
                v-if="formData.cardtype==1"
                v-model="formData.num"
                :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                error-message-align="right"
                label="身份证号"
                input-align="right"
                clearable
                placeholder="请输入身份证号"
            />

            <van-field
                v-model="formData.huzhao"
                v-if="formData.cardtype!=1"
                label="证件号码"
                :rules="[{ required: true, message: '证件号码不能为空' }]"
                error-message-align="right"
                input-align="right"
                clearable
                placeholder="请输入证件号码"
            />


          </van-cell-group>

          <div class="savebtn">
            <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
                native-type="submit">确定
            </van-button>
          </div>
        </van-form>
      </div>
    </van-popup>

    <van-dialog v-model="cSizeShow" title="衣服尺码表">
      <img @click="picShow(key,cSizePicList)" v-for="(pic,key) in cSizePicList" :src="pic" style="width: 100%"/>
    </van-dialog>
    <van-dialog v-model="fSizeShow" title="鞋码表">
      <p style="padding: 10px; text-align: center">此鞋型偏小，建议选大一码</p>
      <img :src="fSizePicList[0]" @click="picShow(0,fSizePicList)" style="width: 100%"/>
    </van-dialog>
    <van-dialog v-model="showTemplate" title="导入模板信息">
      <div class="operate-desc-left">复制下面的链接，用电脑端打开，进行批量导入操作</div>
      <!--      <div class="operate-desc-left" @click="download" style="color: #1989fa;">考级人员批量导入模版下载</div>-->
      <div class="operate-desc-left" v-clipboard:copy="row.share"
           v-clipboard:success="onCopy"
           v-clipboard:error="onError" style="color: #666">导入模板链接地址：{{ row.share }}
        <div class="small-button">复制</div>
      </div>
      <!--        <div class="operate-desc-left" @click="download" style="color: #1989fa;">训练营报名批量导入模版下载</div>-->
    </van-dialog>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.small-button {
  height: 30px;
  padding: 0 8px;
  font-size: 12px;
  line-height: 30px;
  color: #323233;
  background-color: #fff;
  border: 1px solid #ebedf0;
  display: inline-block;
}

.memberResultWrap {
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}

.memberResultWrap .memberLi {
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}

.memberResultWrap .memberLi .van-tag {
  width: auto !important;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}

</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Dialog,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
  ImagePreview
} from 'vant';

import SubjectJiaolianPicker from '@/components/picker/SubjectJiaolianPicker.vue';
import YundongyuanPicker from '@/components/picker/YundongyuanPicker.vue'; 


Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button).use(Dialog);
export default {
  name: 'HuiyiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
  },
  data: function () {
    return {
      validator,
      playMusicUrl: '',
      thisMemberIndex: 0,
      saveLoading: false,
      isLoading: false,
      showNumTypePicker: false,
      showServiceTypePicker: false,
      addShow: false,
      show_share_panel: false,
      numTypeColumns: ['身份证', '护照'],
      showArea: false,
      showTemplate: false,
      areaList: {},
      thismember: {},
      copy_text: 'cccc',
      areaValue: '',
      submitType: '',
      subject_name: '',
      subjectArray: [],
      row: {
        id: 0,
        member_list: [],
        service_options: [],
        extra_field: [],
        cplimits:[],
        jllimits:[],
      },
      formData: {
        name: '11',
        num: '222',
        cardtype: 2,
        footsize: '',
        csize: '',
        is_join_exame: 2,
        join_exame_name: '',
        numTypeName: '身份证',
      },

      fSizeShow: false,
      cSizeShow: false,
      cSizePicList: ['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/7fd2e382afe6f9bd49b3ce9a8ae37a24.png', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/8fb609af0a199bea84da2ff641aacf1f.png'],
      fSizePicList: ['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/33e31ebf9997638013aacb02ed5eeb41.png'],
    }
  },
  filters: {},
  mounted() {
    document.title = '信息补充';

    let that = this;
    that.areaList = area;
    that.row.id = this.$route.query.id;
    if (that.row.id) {
      this.fetch();
      
    } 
    setTimeout(() =>{
      //  this.onMemberSubmit({})
    })
  },
  watch: {
    formData() {
    }
  },
  computed: {
    serviceTypeColumns() {
      // console.log('this.row.member_list', this.row.member_list)
      return this.row.member_list[this.thisMemberIndex].service_options.map(item => {
        return item.name + '(¥' + item.price + ')';
      })
    }

  },
  destroyed() {
  },
  methods: {
    fieldclick(field){
      if(typeof field.pics !='undefined'){
        if(field.pics.length>0){
          this.cSizePicList = field.pics
          this.cSizeShow=true 
        }
      }
    },
    onQuestion() {
      console.log('onQuestion')
    },

    onRefresh() {
      setTimeout(() => {
        Toast('刷新成功');
        this.fetch()
      }, 800);
    },

    onMemberAdd() {
      this.addShow = true;
      this.formData = {
        name: '',
        num: '',
        cardtype: 1,
        footsize: '',
        csize: '',
        is_join_exame: 2,
        join_exame_name: '',
        numTypeName: '身份证',
      };
    },
    memberRemove(item, index) {
      let that = this;
      let notice = '确认删除' + item.name + '(' + item.num + ')' + '吗?';
      Dialog.confirm({
        title: '确认',
        message: notice
      })
          .then(() => {
            // on confirm
            console.log('subjectRemove');
            if (!item.id) {
              that.row.member_list.splice(index, 1);
              return
            }
            that.$api.post('/api/huiyi/memberDelete', {
              'baoming_id': that.row.id,
              'member_id': item.id
            }, (res) => {
              that.row.member_list.splice(index, 1);
            }, (res) => {
              Toast.fail(res.msg);
            })

          })
          .catch(() => {
            // on cancel
          });
    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.cardtype = index + 1;
      this.showNumTypePicker = false;
    },
    onServiceConfirm(value, index) {
      this.row.member_list[this.thisMemberIndex].serviceName = value;
      this.row.member_list[this.thisMemberIndex].serviceDesc = this.row.member_list[this.thisMemberIndex].service_options[index].note;
      this.row.member_list[this.thisMemberIndex].serviceType = index + 1;
      this.showServiceTypePicker = false;
    },
    onMemberSubmit(values) {
      console.log('onMemberSubmit-values', values);
      console.log('onMemberSubmitsubmitType', this.submitType);
      console.log('formData', this.formData);


      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;

      that.$api.post('/api/huiyi/checkApplyNameNum', {
        name: that.formData.name,
        num: this.formData.cardtype == 1 ? this.formData.num : this.formData.huzhao,
        numtype: that.formData.cardtype,
        baoming_id: that.row.id
      }, (res) => {
        that.saveLoading = false;
        let sex = '';
        if (this.formData.cardtype == 1) {
          if (this.formData.num.substr(17, 1) % 2 == 0) {
            sex = '男';
          } else {
            sex = '女';
          }
        }

        let jsondata = {};
        if (that.row.extra_field && that.row.extra_field.length > 0) {
          this.row.extra_field.map((field, findex) => {
            if(field.type =='pic'||field.type =='checkbox'){
              jsondata[field.label] = [];
            }else{ 
              jsondata[field.label] = '';
            }
          });
        }

        this.row.member_list.push({
          name: this.formData.name,
          levelPass:res.data.levelPass?true:false,
          phone: this.row.member_list.length==0? this.row.phone:'',
          num: this.formData.cardtype == 1 ? this.formData.num : this.formData.huzhao,
          user_id: this.row.user_id,
          baoming_id: this.row.id,
          service_options: res.data.service_options,
          sex: sex,
          jsondata: jsondata,
        })
        this.addShow = false;

      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })


    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      let valiOk = true;

      if (that.row.member_list.length == 0) {
        Toast('请至少新增一个人员');
        return;
      }
      console.log(that.row.member_list)
      that.row.member_list.map((item, index) => {
        if (!item.sex) {
          Toast('请选择人员' + (index + 1) + '的性别');
          valiOk = false;
          return;
        }
        if (!item.serviceName) {
          Toast('请选择人员' + (index + 1) + '的服务套餐');
          valiOk = false;
          return;
        }
      });
      if (!valiOk) {
        return;
      }



      let member_list = that.row.member_list.map(item => {
                return {
                  'id': item.id || 0,
                  'name': item.name,
                  'num': item.num,
                  'danwei': this.row.danwei,
                  'sex': item.sex,
                  'phone': item.phone,
                  'weixin': item.weixin,
                  'jsondata': item.jsondata,
                  'footsize': item.footsize,
                  'csize': item.csize,
                  'is_join_exame': item.is_join_exame,
                  'join_exame_name': item.join_exame_name,
                  'service_id': this.row.member_list[this.thisMemberIndex].service_options[item.serviceType - 1].id,
                  'price': this.row.member_list[this.thisMemberIndex].service_options[item.serviceType - 1].price
                }
              })
              console.log('member_list',member_list)

      // that.saveLoading = true;
              
      // return ;
      that.$api.post('/api/huiyi/membersave', {
        'baoming_id': that.row.id,
        'is_confirm':that.$route.query.edit||0,
        'member_list': that.row.member_list.map(item => {
          return {
            'id': item.id || 0,
            'name': item.name,
            'num': item.num,
            'danwei': this.row.danwei,
            'sex': item.sex,
            'phone': item.phone,
            'weixin': item.weixin,
            'jsondata': item.jsondata,
            'footsize': item.footsize,
            'csize': item.csize,
            'is_join_exame': item.is_join_exame,
            'join_exame_name': item.join_exame_name,
            'service_id': this.row.member_list[this.thisMemberIndex].service_options[item.serviceType - 1].id,
            'price': this.row.member_list[this.thisMemberIndex].service_options[item.serviceType - 1].price
          }
        })
      }, (res) => {
        if(that.$route.query.edit){ 
          Toast.success('保存成功');
          return 
        }
        if(that.row.gametype == 4){
          rbLink({
            name: 'HuiyiApplyFormStep10',
            query: {
              id: that.row.id
            }
          })

        }else if(that.row.gametype == 6){
          rbLink({
            name: 'HuiyiApplyFormStep30',
            query: {
              id: that.row.id
            }
          })

        }else if(that.row.gametype == 7){
          rbLink({
            name: 'HuiyiApplyFormStep31',
            query: {
              id: that.row.id
            }
          })

        }else if(that.row.gametype == 8){
          rbLink({
            name: 'HuiyiApplyFormStep20',
            query: {
              id: that.row.id
            }
          })

        }else if (that.row.next_gjsb) {
          rbLink({
            name: 'HuiyiApplyFormStep3',
            query: {
              id: that.row.id
            }
          })
        } else {
          rbLink({
            name: 'HuiyiApplyFormStep5',
            query: {
              id: that.row.id
            }
          })

        }
        that.saveLoading = false;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      },true)
    },
    jumToOld(id) {
      rbLink({
        name: 'HuiyiApplyList'
      }, 'replace')
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    goPre() {
      let that = this;
      rbLink({
        name: 'HuiyiApplyFormStep1',
        query: {
          id: that.row.id
        }
      }, 'replace')
    },
    /** Vant CheckboxGroup / PicUploader 依赖数组；历史接口可能给 ""、null 或 JSON 字符串 */
    coerceCheckboxPicValue(value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (value == null || value === '') {
        return [];
      }
      if (typeof value === 'string') {
        const t = value.trim();
        if (!t) return [];
        try {
          const p = JSON.parse(t);
          return Array.isArray(p) ? p : [];
        } catch (e) {
          return [value];
        }
      }
      return [];
    },
    fetch() {
      let that = this;
      that.$api.post('/api/huiyi/step2detail', {
        id: that.row.id
      }, (res) => {
        that.row = res.data;
        // that.cSizePicList = res.data.clothes_pics
        if(that.row.member_list.length==0){
          that.onMemberAdd();
          that.formData.name = that.row.ldname
        }
        that.row.member_list.map(item => {
          item.service_options.map((service, sindex) => {
            if (item.service_id == service.id) {
              that.$set(item, 'serviceType', sindex + 1);
              that.$set(item, 'serviceName', service.name);
              that.$set(item, 'serviceDesc', service.note);
              return;
            }
          });
          // jsondata 历史数据可能为 []、null；checkbox/pic 必须为数组，不能为 ''
          if (!item.jsondata || typeof item.jsondata !== 'object' || Array.isArray(item.jsondata)) {
            that.$set(item, 'jsondata', {});
          }
          (that.row.extra_field || []).forEach((field) => {
            const key = field.label;
            const v = item.jsondata[key];
            if (field.type === 'checkbox' || field.type === 'pic') {
              that.$set(item.jsondata, key, that.coerceCheckboxPicValue(v));
            } else if (typeof v === 'undefined' || v === null) {
              that.$set(item.jsondata, key, '');
            }
          });
        })

        that.isLoading = false;

      }, (res) => {
        Toast.fail(res.msg);
      })
    },


    shareWeixinFriend() {
      console.log('shareWeixinFriend')
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinFriend',
          query: that.row.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
    shareWeixinTimeLine() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinTimeLine',
          query: that.row.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;

      }
    },

    picShow(index, list) {
      ImagePreview({
        images: list,
        startPosition: index,
      });
    },

    onCopy(e) {
      Toast.success('复制成功');
    },
    onError(e) {
      console.log('复制失败！');
    },

    download() {
      appEvent({
        name: 'downloadFile',
        query: {
          name: '训练营报名批量导入表模版',
          url: 'https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2021-07-21/1626854723732285.xlsx'
        }
      });
    },

  }
}
</script>



// WEBPACK FOOTER //
// HuiyiApplyFormStep2.vue?3c6c3886